import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import menu from "./reducers/menuReducer";
import { userReducer } from "./reducers/userReducer";
import { storeReducer } from "./reducers/storeReducer";
import { orderReducer } from "./reducers/orderReducer";
import { dashboardReducer } from "./reducers/dashboardReducer";
import { merchantReducer } from "./reducers/merchant/merchantReducer";
import { productReducer } from "./reducers/productReducer";
import { remitterReducer } from "./reducers/remitterReducer";
import { dynamicShippingReducer } from "./reducers/dynamicShippingReducer";
import { merchantHoursReducer } from "./reducers/merchant/merchantHoursReducer";

export const reducers = combineReducers({
  menu,
  merchant: merchantReducer,
  merchantHours: merchantHoursReducer,
  store: storeReducer,
  order: orderReducer,
  user: userReducer,
  remitter: remitterReducer,
  dashboard: dashboardReducer,
  products: productReducer,
  dynamicShipping: dynamicShippingReducer
});
const rootReducer = (state, action) => {
  if (action.type === 'USER/LOG_OUT_USER_SUCCESS') {
    state = {}
  }
  return reducers(state, action)
}
const configureStore = () => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
  return store;
}

const store = configureStore()
export default store
